import { APPLICATIONS_BROWNOUT_WARNING_MESSAGE_UPDATE, SCREENING_BROWNOUT_UPDATE } from '../constants/actionTypes';

const initState = () => ({
  applicationsBrownoutWarningMessage: null,
  screeningBrownoutMessage: null,
});

const updateApplicationsBrownoutData = (state, payload) => {
  const { applicationsBrownoutWarningMessage } = payload;
  const newState = { ...state, applicationsBrownoutWarningMessage };
  return newState;
};

const updateScreeningBrownoutMessage = (state, payload) => {
  const { screeningBrownoutMessage } = payload;
  return {
    ...state,
    screeningBrownoutMessage,
  };
};

const applicationsBrownout = (state = initState(), action = {}) => {
  const { type, payload = {} } = action;

  switch (type) {
    case APPLICATIONS_BROWNOUT_WARNING_MESSAGE_UPDATE:
      return updateApplicationsBrownoutData(state, payload);
    case SCREENING_BROWNOUT_UPDATE:
      return updateScreeningBrownoutMessage(state, payload);
    default:
      return state;
  }
};

export default applicationsBrownout;
